const fallback = {
  'pageType': null,
  'pageHeading': null,
  'pageTitle': null,
  'canonicalUrl': null,
  'subPageType': null,
  'keywords': '',
  'description': null,
  'pageLayout': 'GlobalBanner',
  'brandName': null,
  'customerAuth': 'NONE',
  'fullWidth': null,
  'slotNames': [
    'banner-1',
    'banner-2',
    'banner-3',
    'banner-4'
  ],
  'slotData': {
    'banner-3': {
      'backgroundColor': '#e5f1f8',
      'pf_rd_p': '90c1ae2b-2fc3-4624-870b-bb0220ceeae3',
      'color': '##1f1f1f',
      'textAlign': 'center',
      'pf_rd_r': 'E6A2DB9B18704A1F9DDE',
      'gae': 'GlobalBanner-afterpay-2021',
      'componentName': 'DummyComponent',
      'href': '/c/afterpay',
      'linktext': 'Learn More',
      'creativeID': 'bb2c644f-5df7-4ef8-a6e1-d6ac4024533f',
      'content': '<strong>Introducing Afterpay!</strong> Buy now, pay later. No Interest, ever!'
    },
    'banner-4': {
      'backgroundColor': '#e5f1f8',
      'pf_rd_p': '25833463-dce5-401c-a8ba-2494ab19b64d',
      'color': '#1f1f1f',
      'textAlign': 'center',
      'pf_rd_r': 'E6A2DB9B18704A1F9DDE',
      'gae': 'free-ups-pickup',
      'componentName': 'DummyComponent',
      'href': '/c/return-trans-options',
      'linktext': 'Learn More',
      'creativeID': '8198aa82-ad0c-4895-86b1-91adcc1a6084',
      'content': '<strong>Easy Returns:</strong> FREE UPS Pickups from your home (no printer required)!'
    },
    'banner-1': {
      'backgroundColor': '#e5f1f8',
      'color': '#1f1f1f',
      'textAlign': 'center',
      'gae': 'GlobalBanner-092821-VM-none-Home',
      'linkColor': '#1f1f1f',
      'creativeID': '57826b69-978f-4d9b-b8cf-19f98dd01abc',
      'content': 'Be the first to shop the newest home styles—now on Zappos!',
      'pf_rd_p': '7539ec75-65c2-4ff5-9ca6-d6d4ee320153',
      'pf_rd_r': 'E6A2DB9B18704A1F9DDE',
      'linkColorHover': '#0076bd',
      'linkColorVisited': '#003953',
      'componentName': 'DummyComponent',
      'href': '/c/home',
      'linktext': 'Shop Home Now'
    },
    'banner-2': {
      'backgroundColor': '#e5f1f8',
      'pf_rd_p': '1809ab9e-175b-4ba5-9cf3-c3fae883b071',
      'color': '##1f1f1f',
      'textAlign': 'center',
      'pf_rd_r': 'E6A2DB9B18704A1F9DDE',
      'gae': 'GlobalBanner-071122-VM-AllSegments-BTSGuide',
      'componentName': 'DummyComponent',
      'href': '/e/back-to-school',
      'linktext': 'Shop Kids\' Styles',
      'creativeID': 'c7795de4-ef18-4403-bb09-895b3a7fd8dd',
      'content': 'Say Goodbye to Stress with Our Back-to-School Guide!'
    }
  }
};

export default fallback;
